import { useState, useCallback } from 'react';
import { AuthService } from '@/services/authService';

interface AdminVerificationResult {
  isAdmin: boolean;
  isLoading: boolean;
  error: string | null;
  verifyAdmin: () => Promise<boolean>;
}

export const useAdminVerification = (): AdminVerificationResult => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const verifyAdmin = useCallback(async (): Promise<boolean> => {
    setIsLoading(true);
    setError(null);

    try {
      console.log('🔐 useAdminVerification: Calling verify-admin endpoint...');
      const result = await AuthService.verifyAdmin();
      console.log('✅ useAdminVerification: Result received:', result);

      if (!result.isAdmin) {
        console.log('❌ useAdminVerification: User is not admin');
        return false;
      }

      console.log('🎉 useAdminVerification: User is admin!');
      return true;
    } catch (error: any) {
      console.error('❌ useAdminVerification: Admin verification failed:', error);

      // Solo per errori 403 (Forbidden), considera l'utente come non-admin
      // Per 401 potrebbe essere un problema temporaneo di token
      if (error.response?.status === 403) {
        console.log('🚫 useAdminVerification: Access forbidden - user likely not admin');
        return false;
      }

      // Per 401 o altri errori, potrebbe essere temporaneo - non fare logout
      setError('Errore nella verifica dei permessi');
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isAdmin: true, // Questo sarà determinato dalla chiamata verifyAdmin
    isLoading,
    error,
    verifyAdmin
  };
};